module.exports = __webpack_public_path__ + "static/media/play-yellow.61700a12.svg";